import { render } from "./UploadTag.vue?vue&type=template&id=7d1ce68c&scoped=true"
import script from "./UploadTag.vue?vue&type=script&lang=js"
export * from "./UploadTag.vue?vue&type=script&lang=js"

import "./UploadTag.vue?vue&type=style&index=0&id=7d1ce68c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d1ce68c"]])

export default __exports__